import useModalReducer from "hooks/useModal";
import { useState, useEffect } from "react";
import { useCallback } from "react";
import { ViewClaimsModal } from "../ViewClaimsModal";
import { ClaimsTable } from "../ClaimsTable";
import { claimsTableModalEmitter } from "../ClaimsTable/config";
import { centreOptions } from "constants";

const pendingClaimsTableFilters = [
	{
		filterName: "date_from",
		operator: "contains",
		placeholder: "Date",
		type: "date",
		label: "Date From",
	},
	{
		filterName: "date_to",
		operator: "contains",
		placeholder: "Date",
		type: "date",
		label: "Date To",
	},
	{ filterName: "staff_name", operator: "contains", placeholder: "Staff Name" },
	{
		filterName: "status",
		operator: "contains",
		label: "Status",
		type: "hidden",
		value: "pending",
	},
	{
		filterName: "centre",
		operator: "contains",
		label: "Centre",
		type: "select",
		options: [{ value: null, label: "All" }, ...centreOptions],
	},
];

const PendingClaimsPage = () => {
	const { state, dispatch, actions } = useModalReducer();

	const showModal = useCallback(
		(row) => {
			dispatch({
				type: actions.OPEN,
				payload: row,
			});
		},
		[dispatch, actions]
	);

	const hideModal = useCallback(
		(row) => {
			dispatch({ type: actions.CLOSE });
		},
		[dispatch, actions]
	);

	useEffect(() => {
		const unbind = claimsTableModalEmitter.on("showModal", showModal);
		return unbind;
	}, [showModal]);

	const [refetchCheck, setRefetchCheck] = useState(false);

	const refetch = useCallback(() => setRefetchCheck((prev) => !prev), []);

	return (
		<div className="relative content">
			<ViewClaimsModal state={state} showModal={showModal} hideModal={hideModal} approveActions refetch={refetch} />
			<ClaimsTable
				self={false}
				filters={pendingClaimsTableFilters}
				showModal={showModal}
				title="Pending Claims"
				parentRefetchCheck={refetchCheck}
			/>
		</div>
	);
};

export default PendingClaimsPage;
